<template>
  <div
    class="content-editable"
    :class="{ size, multiline: multiline }"
    :style="style"
    test-id="al-content-editable"
    @click.stop="onClick"
    @mouseenter="showInput"
    @mouseleave="onMouseLeve"
  >
    <div
      class="content-editable-item content-editable-value"
      :class="[{ hidden: isInputActivated }, { invalid: !isValid }]"
    >
      <span class="editable-field">
        <slot />
      </span>
    </div>

    <div
      v-show="isEmpty(value)"
      class="content-editable-item content-editable-placeholder"
      :class="[{ hidden: !isInputActivated && !isEmpty(value) }, { invalid: !isValid }]"
    >
      <slot name="placeholder">
        <span class="editable-field">{{ placeholder }}</span>
      </slot>
    </div>
    <al-input
      v-show="isInputActivated"
      ref="input"
      :placeholder="placeholder"
      :value="value"
      :type="typeInput"
      autocomplete="off"
      :pattern="pattern"
      :state="!isValid ? false : null"
      :size="size"
      :disabled="disabled"
      class="content-editable-item content-editable-input"
      @blur="onBlur"
      @input="onInput"
      @focus="focus"
      @keyup.native.enter="$event.target.blur()"
    />
  </div>
</template>

<script>
import AlInput from '../../form-components/input/AlInput.vue';

const type = {
  time: 'time-custom',
  text: 'text'
};

export default {
  components: {
    AlInput
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    editable: {
      type: Boolean,
      default: true
    },
    multiline: {
      type: Boolean,
      default: false
    },
    isFocus: Boolean,
    size: {
      type: String,
      default: 'lg'
    },
    width: {
      type: [String, Number],
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },

    isValid: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isInputActivated: false,
      valid: true
    };
  },
  computed: {
    style() {
      const widthSyle = this.width ? `width:${this.width}px; min-width:${this.width}px` : null;
      return widthSyle || '';
    },
    typeInput() {
      return this.type === type.time ? type.text : this.type;
    },
    pattern() {
      return this.type === type.type ? '^[0-9*:+]+$' : null;
    }
  },
  mounted() {
    if (this.isFocus) {
      this.setInputFocus(this.isFocus);
    }
  },
  methods: {
    setInputFocus(focus) {
      this.isInputActivated = focus;
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    onClick() {
      if (!this.editable) {
        return;
      }
      this.showInput();
    },
    focus(evt) {
      this.$emit('focus', evt);
      this.isInputClicked = true;
    },
    onBlur(event) {
      this.exitInput(event.target.value);
    },
    onInput(value) {
      this.$emit('input', value);
    },
    onMouseLeve() {
      if (!this.isInputClicked) {
        this.hideInput();
      }
    },
    exitInput(text) {
      this.isInputClicked = false;
      this.hideInput();
      this.$emit('blur', text);
    },
    showInput() {
      this.isInputActivated = this.editable;
    },
    hideInput() {
      this.isInputActivated = false;
    },
    isEmpty(str = '') {
      if (typeof str === 'number') {
        return str === 0;
      }
      return !str || str.trim() === 0;
    }
  }
};
</script>

<style lang="scss">
$min-width: 100px;

.content-editable {
  align-items: center;
  display: flex;
  height: 36px;
  min-width: $min-width;
  position: relative;
  width: 100%;

  &-value,
  &-placeholder,
  &-input {
    align-items: center;
    display: flex;
    height: 100%;
    min-width: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  &-value,
  &-placeholder {
    border: 1px solid transparent;
    padding: 0 9px;

    span.editable-field > *,
    span.editable-field {
      display: block;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: auto;
    }

    &.invalid {
      span.editable-field > * {
        color: color(red) !important;
      }
    }
  }

  &.lg {
    min-height: 45px;
  }

  &.multiline {
    height: auto;

    .content-editable-value {
      height: auto;
      position: relative;

      span.editable-field > *,
      span.editable-field {
        overflow: inherit;
        white-space: normal;
      }

      h6 {
        font-family: inherit;
        font-weight: 500;
      }
    }
  }

  .hidden {
    opacity: 0;
  }

  .content-editable-input {
    input {
      color: inherit;
      font-family: inherit;
      font-size: inherit;
      font-weight: inherit;

      &:focus {
        color: color(black, lighten, 1) !important;
        outline-color: color(green);
      }
    }
  }

  .content-editable-placeholder {
    color: color(black, lighten, 3);
  }
}
</style>
